import { Container, Grid } from '@mui/material';
import PosicaoAtualEstoque from './components/PosicaoAtualEstoque';
import SolicitacoesRessuprimento from './components/SolicitacoesRessuprimento';
import SolicitarRessuprimentoDialog from './components/SolicitarRessuprimentoDialog';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import axiosClient from '../../lib/axios';
import { useQuery } from 'react-query';
import ScreenBanner from '../../components/ScreenBanner';
import RefreshIcon from '@mui/icons-material/RefreshOutlined'
import ListaAcoesRapidas, { TItemAcaoRapida } from '../../components/ListaAcoesRapidas';
import PermissionGuard, { usePermission } from '../../components/PermissionGuard';
import { useNavigate } from 'react-router-dom';
import { useModalDetalheProcesso } from '../../components/ModalContexts/ModalDetalheProcessoContext';
import DialogSolicitarCompraProduto from './components/MICompras/DialogSolicitarCompraProduto';

export default function Estoque() {

    const navigate = useNavigate();
    const { openModal } = useModalDetalheProcesso()

    // Hooks de permissão no nível superior
    const podeSolicitarRessuprimento = usePermission('estoque.ressuprimento');
    const podeSolicitarCompra = usePermission('estoque.solicitar-compra-produto');
    const podeListarProdutos = usePermission('estoque.listar-produtos');

    const [modais, setModais] = useState<EstoqueModal>({
        solicitarRessuprimento: false,
        solicitarCompraProduto: false
    });

    const [processo, setProcesso] = useState<string | null>(null)

    const { data, isLoading, refetch } = useQuery({
        queryKey: 'pesquisar-processos',
        queryFn: () => axiosClient.get("/pesquisar-processos", {
            params: {
                fluxo_id: "SOLICITACAO_RESSUPRIMENTO"
            }
        }),
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    //Funções Manipuladoras
    const handleOpenModal = useCallback((prop: keyof EstoqueModal, value: boolean) => {
        setModais(prevState => ({
            ...prevState,
            [prop]: value
        }))
    }, [])
    //

    const listaAcoesRapidas: Array<TItemAcaoRapida> = useMemo(() => [
        {
            label: "Solicitar ressuprimento",
            icon: <RefreshIcon color="primary" />,
            action: () => handleOpenModal("solicitarRessuprimento", true),
            havePermission: podeSolicitarRessuprimento
        },
        {
            label: "Solicitar compra de produto",
            icon: <RefreshIcon color="primary" />,
            action: () => handleOpenModal("solicitarCompraProduto", true),
            havePermission: podeSolicitarCompra
        },
    ], [handleOpenModal, navigate, podeSolicitarRessuprimento, podeListarProdutos, podeSolicitarCompra])

    useEffect(() => {
        if (processo) {
            openModal(processo)
            setProcesso(null)
        }
    }, [processo])

    return (
        <>
            <ScreenBanner title="Estoque" />

            <PermissionGuard permissionId="estoque.dashboard">
                <Container>
                    <Grid container spacing={2} mt={2}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 8 }}>
                            <PosicaoAtualEstoque />
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <SolicitacoesRessuprimento processos={data?.data} isLoading={isLoading} />
                        </Grid>
                    </Grid>
                </Container>
            </PermissionGuard>

            {
                modais.solicitarRessuprimento &&
                <SolicitarRessuprimentoDialog
                    handleChangeProcesso={(item: string) => setProcesso(item)}
                    open={modais.solicitarRessuprimento}
                    onCreate={(codigo: string) => {
                        setModais({ ...modais, ...{ solicitarRessuprimento: false } });
                        refetch();
                        enqueueSnackbar('Solicitação de ressuprimento #' + codigo + ' foi enviada com sucesso!', { variant: 'success' });
                    }}
                    onFail={() => {
                        enqueueSnackbar("Erro ao criar solicitação de ressuprimento", {
                            variant: "error"
                        })
                    }}
                    handleClose={() => {
                        setModais({ ...modais, ...{ solicitarRessuprimento: false } });
                    }}
                />
            }
            {
                modais.solicitarCompraProduto &&
                    <DialogSolicitarCompraProduto
                        open={modais.solicitarCompraProduto}
                        onClose={() => handleOpenModal('solicitarCompraProduto', false)}
                    />
            }
        </>
    );
}

type EstoqueModal = {
    solicitarRessuprimento: boolean;
    solicitarCompraProduto: boolean;
}